import React from 'react';

const GallerySection = () => {
  const galleryImages = [
    '/gallery1.jpg',
    '/gallery2.jpg',
    '/gallery3.jpg',
    '/gallery4.jpg',
    '/gallery5.jpg',
    '/gallery6.jpg',
    '/gallery7.jpg',
    '/gallery8.jpg',
    '/gallery9.jpg',
    '/gallery10.jpg',
    '/gallery11.jpg',
    '/gallery12.jpg',
    '/gallery13.jpg',
    '/gallery14.jpg',
    '/gallery15.jpg',
    '/gallery16.jpg'
  ];

  return (
    <section className="py-12 md:py-16 bg-gradient-to-b from-white to-gray-50 text-center">
      <div className="container mx-auto px-4">
        <h2 className="font-bold text-2xl md:text-3xl mb-8 text-gray-900">
          <span className="text-red-600">Gallery</span> - Our Precious Moments
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mt-8">
          {galleryImages.map((image, index) => (
            <div 
              key={index} 
              className="overflow-hidden rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 group aspect-square"
            >
              <img
                src={image}
                alt={`Gallery ${index + 1}`}
                className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;